"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given number is greater than zero.
 *
 * @export
 * @class IsPositiveValidator
 * @implements {PropertyValidator<number>}
 */
class IsPositiveValidator {
    isValid(input) {
        if (input) {
            return input > 0;
        }
        return false;
    }
}
exports.IsPositiveValidator = IsPositiveValidator;
//# sourceMappingURL=IsPositiveValidator.js.map